/*eslint-disable*/
import React, { useState, useEffect } from 'react'
import { Button, Icon } from 'semantic-ui-react'
import EditModal from '../../commonComponent/editModal'
import DeleteModal from '../../deleteComponent/deleteModal'
import DeleteAxios from '../../axiosComponent/deleteAxios'
import FormikEditVehicleType from './editVehicleType'
import cogoToast from 'cogo-toast'

function VehTypeActionButton(props) {
    const [editModal, setEditModal] = useState(false)
    const [openBox, setopenBox] = useState(false)
    const [success, setsuccess] = useState(false)
    let handleEditClose = () => {
        setEditModal(false)
    }
    let handleClose = () => {
        console.log('ddds')
        setopenBox(false)
    }
    let handleDelete = () => {
        setsuccess(true)
        let id = props.data.id
        DeleteAxios({
            url: `masters/vehicleTypeMaster/${id}`,
            deleteItems: {
                vehTypeId: id
            },
            deleted: (data) => {
                if (data && data.status === 200) {
                    cogoToast.success(data.message)
                    setsuccess(false)
                    setTimeout(() => {
                        window.location.href = "/vehicle-type" 
                    }, 1000);
                }
            }
        })

    }
    let handleOpenEdit = (e) => {
        let mainData = props.data   
        let history = props.agGridReact.props.BaseUrl.history
        console.log('open edit history: ', mainData)
        history.push({ pathname: '/edit-vehicletype/' + mainData.id })
        
    }
    let handleOpenDelete = (e) => {
        setopenBox(true)
    }
    return (
        <>
            <Button basic size="mini" type="button" icon onClick={handleOpenEdit}><Icon name="edit" color="green" /></Button>
            <Button onClick={handleOpenDelete} basic size="mini" type="button" icon> <Icon name="trash" color="red" /></Button>
            <DeleteModal isloading={success} open={openBox} onClose={handleClose} handleDelete={handleDelete} />
            <EditModal size="mini" open={editModal} onClose={handleEditClose}>
                <FormikEditVehicleType getUpdate={props.agGridReact.props} vehicleType={props.data} handleClose={handleEditClose} />
            </EditModal>
        </>
    )
}

export default VehTypeActionButton
